import * as types from "./types";

const initialState = {
  rows: [],
  loading: false,
  error: null,
};

export default function limitReducer(state = initialState, action) {
  switch (action.type) {
    case types.FETCH_LIMIT_ROWS:
      return {
        ...state,
        rows: action.payload,
      };
    case types.API_STATUS:
      return {
        ...state,
        apiStatus: action.payload,
      };

    case types.FETCH_LIMIT_DROPDOWN:
      return {
        ...state,
        dropdown: action.payload,
      };
    case types.ADD_LIMIT:
      return {
        ...state,
        added_limit: action.payload,
      };
    case types.CLEAR_LIMIT_MESSAGE:
      return {
        ...state,
        limitOperation: {
          ...state.limitOperation,
          message: "",
          data: null,
          status: null,
        },
      };

    case types.EXPORT_PDF_DATA:
      return {
        ...state,
        pdf: action.payload,
      };
    case types.EXPORT_XL_DATA:
      return {
        ...state,
        xl: action.payload,
      };
    case types.IMPORT_LIMIT_DATA:
      return {
        ...state,
        import_xl: action.payload,
      };
    case types.GET_PARA_LIST:
      return {
        ...state,
        parameter: action.payload,
      };

    case types.DELETELIMIT:
      return {
        ...state,
        delete: action.payload,
      };
    case types.UPDATELIMIT:
      return {
        ...state,
        update: action.payload,
      };

    case types.LIMITOPERATION:
      return {
        ...state,
        limitOperation: action.payload,
      };

    case types.FETCH_AUDIT_ROWS:
      return {
        ...state,
        audit_logs: action.payload,
      };

    default:
      return state;
  }
}
